import React from "react";
import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ImportFile from "./ImportFile";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessAction, resetBusinessList } from "../../actions/businessInfo";
import { useEffect } from "react";
import {
  BOB_SERVICES,
  PROFILE_ACTION,
  PROFILE_STATUS,
  PUSH_NOTIFICATION_MODULE,
  SELECT_BOX_THEME,
  styleSelect,
} from "../../constants";
import { Controller } from "react-hook-form";
import { toast } from "react-hot-toast";
import ProfileForm, { getPotentialPurpose } from "./ProfileForm";
import ContactInfo from "./ContactInfo";
import { updateBusinessProfileAction } from "../../actions/bookOfBusiness";
import Select from "react-select";
import TimeFormat from "../../components/timeFormat/timeFormat";
import ConfirmMeeting from "./ConfirmMeeting";
import debounce from 'lodash/debounce';
import SendToChat from "./SendToChat";
import { createChat } from "../../services/api";
import { RoutesPaths } from "../../Router/constant";
import { useNavigate } from "react-router";
import { getAllChatList } from "../../actions/chatv2";
import { getAllUserListAction } from "../../actions/user";
import ViewProfileModal from "../../components/ViewProfileModal";
import { addProfileToCampaignAction, getCampaignListAction } from "../../actions/peopleai";

const cleanNamePart = (value) => {
  const namePart = String(value || "").trim();
  return ["undefined", "null"].includes(namePart.toLowerCase()) ? "" : namePart;
};

const cleanName = (value) => (
  String(value || "")
    .split(" ")
    .map(cleanNamePart)
    .filter(Boolean)
    .join(" ")
);

const getProfileName = (profile) => (
  [
    cleanNamePart(profile?.first_name),
    cleanNamePart(profile?.last_name)
  ].filter(Boolean).join(" ") || cleanName(profile?.name) || "-"
);

export default function ProfileDetail({
  activePage,
  count,
  handlePageClick,
  businessProfiles,
  getValues,
  control,
  limit,
  setStatus,
  profileTab,
  setPage,
  setActivePage,
  bookOfBusiness,
  bookOfBusinessResponseService,
  setSearch,
  search
}) {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { businessInfo } = useSelector((state) => state.businessInfo);
  const [isEdit, setIsEdit] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [bobSelected, setBobSelected] = useState(null);
  const [meetingOpen, setMeetingOpen] = useState(false);
  const [sendToChatModal, setSendToChatModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [selectedProfiles, setSelectedProfiles] = useState({});
  const [campaignModalOpen, setCampaignModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [bulkCampaignLoading, setBulkCampaignLoading] = useState(false);

  const [sendToChatDetail, setSendToChatDetail] = useState(null);
  const [meetingDetailItem, setMeetingDetailsItem] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const { user } = useSelector(state => state.user)
  const { campaignList } = useSelector((state) => state.peopleai);
  const [customCompanyDetails, setCustomCompanyDetails] = useState({
    bookOfBusinessGroup: [],
    user: []
  });

  useEffect(() => {
    dispatch(getAllUserListAction())
  }, [dispatch])
  // useEffect(() => {
  //   // dispatch(getBusinessAction(1, 100));
  // }, [dispatch]);

  const handleImport = (value) => {
    if (value === "import") {
      setImportOpen(true);
    } else {
      setFormOpen(true);
    }
  };

  const handleForm = async (value, detail) => {
    if (value === "edit") {
      setBobSelected(detail);
      const customCompanyDetails = {
        bookOfBusinessGroup: [detail?.bookOfBusinessGroupId],
        ...detail?.company,
        user: [detail?.user]
      }
      setCustomCompanyDetails(customCompanyDetails)
      setIsEdit(true);
      setFormOpen(true);
    } else {
      handleImport("add");
      setIsEdit(false);
    }
  };

  const handleClone = async (item) => {
    const { status, action } = item;
    if (
      status === PROFILE_STATUS.SUGGESTED_PROFILES ||
      status === PROFILE_STATUS.WARM_PROFILES
    ) {
      var curerntAction = PROFILE_ACTION.ACCEPT;
      if (curerntAction && curerntAction !== action) {
        await dispatch(
          updateBusinessProfileAction(
            item.company._id,
            item.id,
            {
              action: PROFILE_ACTION.ACCEPT,
            },
          )
        );
      }
    }
  };

  const handleContact = (value) => {
    setContactOpen(value);
  };

  const handleConnect = async (item) => {
    const { action } = item;
    var curerntAction = null;

    switch (action) {
      case PROFILE_ACTION.REQUESTED:
        curerntAction = PROFILE_ACTION.REJECTED;
        break;
      case PROFILE_ACTION.SCHEDULED:
        curerntAction = PROFILE_ACTION.REJECTED;
        break;
      case PROFILE_ACTION.CONFIRM:
        curerntAction = PROFILE_ACTION.REJECTED;
        break;
      default:
        break;
    }

    if (curerntAction && curerntAction !== action) {
      await dispatch(
        updateBusinessProfileAction(
          item.company._id,
          item.id,
          {
            action: curerntAction,
          },
        )
      );
    }
  };

  const currentStatus = (item) => {
    const { status, action, eventDetails, company } = item;
    const makePublicCondition = ["Connect", "Schedule a meeting", "Confirm meeting"]
    var actionButton = null;
    switch (status) {
      case PROFILE_STATUS.SUGGESTED_PROFILES:
        actionButton =
          action === PROFILE_ACTION.CONNECT
            ? "Connect"
            : action === PROFILE_ACTION.REQUESTED
              ? "Requested"
              : action === PROFILE_ACTION.REJECTED
                ? "Rejected"
                : action === PROFILE_ACTION.ACCEPT
                  ? "Accepted"
                  : "";
        break;
      case PROFILE_STATUS.WARM_PROFILES:
        actionButton =
          action === PROFILE_ACTION.SCHEDULED
            ? "Schedule a meeting"
            : action === PROFILE_ACTION.REQUESTED
              ? "Requested"
              : action === PROFILE_ACTION.REJECTED
                ? "Rejected"
                : action === PROFILE_ACTION.ACCEPT
                  ? "Accepted"
                  : "";
        break;
      case PROFILE_STATUS.MEETING_REQUESTS:
        actionButton =
          action === PROFILE_ACTION.CONFIRM && eventDetails
            ? "Confirm meeting"
            : action === PROFILE_ACTION.CONFIRM && !eventDetails
              ? "Add meeting details"
              : action === PROFILE_ACTION.RESCHEDULED
                ? "Rescheduled"
                : action === PROFILE_ACTION.RESPOND
                  ? "Meeting confirmed"
                  : action === PROFILE_ACTION.REJECTED
                    ? "Rejected"
                    : action === PROFILE_ACTION.ACCEPT
                      ? "Accepted"
                      : "";
        break;
      default:
        break;
    }
    if (actionButton) {
      return (
        <p className="role">
          {company && company?.isDefault ? (
            makePublicCondition.includes(actionButton) ? 'Make Public' : 'Public'
          ) : (
            actionButton
          )}
        </p>
      );
    } else {
      return "";
    }
  };

  const actionToBeTaken = (item) => {
    const { status, action } = item;
    var actionButton = null;
    switch (status) {
      case PROFILE_STATUS.SUGGESTED_PROFILES:
        actionButton = action === PROFILE_ACTION.REQUESTED ? "Reject" : null;
        break;
      case PROFILE_STATUS.WARM_PROFILES:
        actionButton = action === PROFILE_ACTION.REQUESTED ? "Reject" : null;
        break;
      case PROFILE_STATUS.MEETING_REQUESTS:
        actionButton = action === PROFILE_ACTION.REQUESTED ? "Reject" : null;
        break;
      default:
        break;
    }

    return (
      <>
        {showEditButton(item) && (
          <div
            className="edit"
            onClick={() => handleForm("edit", item)}
          >
            <i className="fa-solid fa-pen"></i>
          </div>
        )}
        {showCloneButton(item) && (
          <div className="edit fill-primary" onClick={() => handleClone(item)}>
            <i className="fa-solid fa-check"></i>
          </div>
        )}

        {showMeetingDetailsButton(item) && (
          <div className="edit fill-primary" onClick={() => handleSetMeetingDetails(item)}>
            <i className="fa-regular fa-handshake"></i>
          </div>
        )}

        {actionButton && (
          <div className="edit btn-c-danger" onClick={() => handleConnect(item)}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        )}
      </>
    )
  };

  const showEditButton = (item) => {
    const acccepShowEdit = [
      PROFILE_ACTION.REQUESTED,
      PROFILE_ACTION.CONNECT,
      PROFILE_ACTION.SCHEDULED,
      PROFILE_ACTION.CONFIRM,
    ];
    const acccepShowEditStatus = [
      PROFILE_STATUS.SUGGESTED_PROFILES,
      PROFILE_STATUS.WARM_PROFILES,
      PROFILE_STATUS.MEETING_REQUESTS,
    ];
    return acccepShowEditStatus.includes(item.status) &&
      acccepShowEdit.includes(item.action)
      ? true
      : false;
  };

  const showCloneButton = (item) => {
    const acccepShowClone = [PROFILE_ACTION.REQUESTED];
    const acceptShowCloneStatus = [
      PROFILE_STATUS.SUGGESTED_PROFILES,
      PROFILE_STATUS.WARM_PROFILES,
    ];
    return acceptShowCloneStatus.includes(item.status) &&
      acccepShowClone.includes(item.action)
      ? true
      : false;
  };

  const formatOptionLabel = ({ companyName, createdAt, user }) => {
    return (
      <div className="menuController">
        <p className="name">{companyName}</p>
        <p><TimeFormat time={createdAt} /></p>
        <p>{getProfileName(user?.[0])}</p>
      </div>
    );
  };


  const handleChange = (inputValue) => {
    setSearchValue(inputValue);
  };

  useEffect(() => {
    const debouncedSearch = debounce((value) => {
      if (value) {
        dispatch(getBusinessAction(1, 100, value,"","","","","","","","",true));
      }
      else {
        dispatch(resetBusinessList())
      }
    }, 1000);
    debouncedSearch(searchValue);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchValue, dispatch]);

  const showMeetingDetailsButton = (item) => {
    const acccepShowMeetingRequest = [PROFILE_ACTION.CONFIRM, PROFILE_ACTION.RESCHEDULED, PROFILE_ACTION.RESPOND];
    const acceptShowMeetingRequestStatus = [PROFILE_STATUS.MEETING_REQUESTS];
    return acceptShowMeetingRequestStatus.includes(item.status) &&
      acccepShowMeetingRequest.includes(item.action)
      ? true
      : false;
  };

  const handleSetMeetingDetails = (item) => {
    setMeetingOpen(true)
    setMeetingDetailsItem(item)
  }

  const handleChatListModal = (item) => {
    setSendToChatModal(true)
    setSendToChatDetail(item)
  }

  const handleChatResponse = async (data) => {
    const innerValue = `${data?.userDetail?.name || "Profile"}`;
    const attributes = {
      module: PUSH_NOTIFICATION_MODULE.BOB_PROFIILE, // Custom attribute
      data: sendToChatDetail,
      participants: [data?.userDetail?.id],
      message: innerValue
    };
    var response = await createChat(attributes);
    navigate(RoutesPaths.MESSAGE_DETAIL + '?room=' + response._id);
    setSendToChatModal(false)
    setSendToChatDetail(null)
  };
  const handleViewProfile = (profile) => {
    setProfileData(profile);
    setOpen(true);
  };

  const getProfileId = (item) => {
    const candidateIds = [
      item?.profileIds,
      item?.profileId,
      item?.id,
      item?._id
    ]
      .flatMap((value) => Array.isArray(value) ? value : [value])
      .filter(Boolean);

    return candidateIds[0] || "";
  };

  const selectedProfileIds = Object.values(selectedProfiles);

  const handleProfileSelect = (item, checked) => {
    const profileId = getProfileId(item);

    if (!profileId) {
      toast.error("Profile id not found");
      return;
    }

    setSelectedProfiles((prev) => {
      const next = { ...prev };
      if (checked) {
        next[profileId] = profileId;
      } else {
        delete next[profileId];
      }
      return next;
    });
  };

  const openCampaignModal = () => {
    if (!selectedProfileIds.length) {
      toast.error("Select at least one profile");
      return;
    }

    dispatch(getCampaignListAction(1, 1000, "", "launched"));
    setCampaignModalOpen(true);
  };

  const closeCampaignModal = () => {
    setCampaignModalOpen(false);
    setSelectedCampaign(null);
  };

  const handleAddSelectedProfilesToCampaign = async () => {
    if (!selectedCampaign) {
      toast.error("Select campaign");
      return;
    }

    if (!selectedProfileIds.length) {
      toast.error("Select at least one profile");
      return;
    }

    setBulkCampaignLoading(true);
    const response = await dispatch(addProfileToCampaignAction({
      profileId: selectedProfileIds,
      campaignId: selectedCampaign?.id || selectedCampaign?._id
    }));
    setBulkCampaignLoading(false);

    if (response?.status) {
      setSelectedProfiles({});
      closeCampaignModal();
    }
  };

  useEffect(() => {
    setSelectedProfiles({});
  }, [activePage, profileTab, search]);

  useEffect(() => {
    setSelectedProfiles({});
  }, [businessProfiles?.data]);


  return (
    <>
      <div className="profileFilterHeader">
        <div className="searchbar">
          <input
            type="search"
            placeholder="Search user"
            name="search"
            id=""
            autoComplete="off"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value.trimLeft());
            }}
          />
          <img src="assets/img/searchIcon.svg" alt="" />
        </div>
        <div className="searchbar searchbarCenter">
          <Controller
            name="companyName"
            control={control}
            render={({ field }) => (
              <Select
                className="select-border"
                theme={SELECT_BOX_THEME}
                {...field}
                styles={styleSelect}
                isClearable={true}
                isSearchable={true}
                options={businessInfo}
                getOptionLabel={(option) => option?.companyName}
                formatOptionLabel={formatOptionLabel}
                onInputChange={handleChange}
                getOptionValue={(option) => option._id}
                placeholder="Search business name"
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
              />
            )}
          />
          <img src="assets/img/searchIcon.svg" alt="" />
        </div>
        <div className="filterButtons">
          {selectedProfileIds.length > 0 && (
            <button
              type="button"
              onClick={openCampaignModal}
              className="customAddButton"
            >
              Add to campaign ({selectedProfileIds.length})
            </button>
          )}
          {/* <button
            type="button"
            onClick={() => handleImport("import")}
            className="customImportButton"
          >
            <img src="assets/img/downloadIcon.svg" alt="" />
            Import
          </button> */}
          <button
            onClick={() => handleForm("add", null)}
            type="button"
            className="customAddButton removePadding"
          >
            Add profile
          </button>
        </div>
      </div>

      <div className="profileCardBody">
        <div className="tableResponsive">
          <table className="profileTable">
            {businessProfiles?.data?.length > 0 && (
              <thead>
                {/* {
                  getValues("companyName") ?
                    <tr>
                      <th>{bookOfBusinessResponseService === BOB_SERVICES.PROFILES ? "Full Name" : BOB_SERVICES.PRODUCT_AND_SERVICES === bookOfBusinessResponseService ? "Product or Service Name" : BOB_SERVICES.COMPANIES === bookOfBusinessResponseService ? "Company name and type" : ""}</th>
                      <th>Sugggested by</th>
                      <th>Potential {bookOfBusinessResponseService === BOB_SERVICES.PROFILES ? "Role" : [BOB_SERVICES.COMPANIES, BOB_SERVICES.PRODUCT_AND_SERVICES].includes(bookOfBusinessResponseService) ? "Purpose" : ""}</th>
                      <th>Industry</th>
                      <th>Contact Info.</th>
                      <th>{bookOfBusinessResponseService === BOB_SERVICES.PROFILES ? "LinkedIn Profile URL" : [BOB_SERVICES.COMPANIES, BOB_SERVICES.PRODUCT_AND_SERVICES].includes(bookOfBusinessResponseService) ? "Landing page URL" : ""}</th>
                      <th>Status</th>
                    </tr>
                    : */}
                <tr>
                  <th className="profileSelectColumn">Select</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Created at</th>
                  <th>LinkedIn Profile URL</th>
                  <th>Location</th>
                  <th>About</th>
                  <th>Action</th>
                </tr>
                {/* // } */}
              </thead>
            )}
            <tbody>
              {businessProfiles?.data?.length > 0 ? (
                businessProfiles?.data?.map((item, index) => (
                  // getValues("companyName") ?
                  //   <tr key={index}>
                  //     <td>
                  //       <p>
                  //         {BOB_SERVICES.PROFILES === bookOfBusinessResponseService ? (item?.first_name ? item?.first_name : "") + " " + (item?.last_name ? item?.last_name : "") : [BOB_SERVICES.COMPANIES, BOB_SERVICES.PRODUCT_AND_SERVICES].includes(bookOfBusinessResponseService) ? (BOB_SERVICES.COMPANIES === bookOfBusinessResponseService ? item.companyProfile : item.serviceProductName) + " " + (BOB_SERVICES.COMPANIES === bookOfBusinessResponseService ? item.companyType : "") : ""}
                  //       </p>
                  //       <p className="detail">{item.country?.name}</p>
                  //     </td>
                  //     <td>
                  //       <p>{item?.user?.first_name ? item?.user?.first_name : ""} {item?.user?.last_name ? item?.user?.last_name : ""}</p>
                  //       {/* <p>{[BOB_SERVICES.PROFILES, BOB_SERVICES.PRODUCT_AND_SERVICES].includes(bookOfBusinessResponseService) ? item.companyProfile : BOB_SERVICES.PRODUCT_AND_SERVICES === bookOfBusinessResponseService ? "From Company / Simple description" : BOB_SERVICES.COMPANIES === bookOfBusinessResponseService ? item.description : ""}</p>
                  //     <p className="detail">
                  //       {item.description}
                  //     </p> */}
                  //     </td>
                  //     <td>
                  //       <p className="role">
                  //         {item?.bookOfBusinessGroupId?.isDefault ? (
                  //           item?.customPotentialPurposeInput
                  //         ) : (
                  //           getPotentialPurpose(item)
                  //         )}
                  //       </p>
                  //     </td>
                  //     <td>
                  //       <p className="role">{item.industry}</p>
                  //     </td>
                  //     <td>
                  //       <button
                  //         onClick={() => handleContact(item)}
                  //         className="contact"
                  //         type="button"
                  //       >
                  //         Contact Info
                  //       </button>
                  //     </td>
                  //     <td>
                  //       <p>
                  //         <a
                  //           target="_blank"
                  //           rel="noreferrer"
                  //           href={bookOfBusinessResponseService === BOB_SERVICES.PROFILES ? item.linkedinUrl : [BOB_SERVICES.COMPANIES, BOB_SERVICES.PRODUCT_AND_SERVICES].includes(bookOfBusinessResponseService) ? item.landingPageUrl : ""}
                  //         >
                  //           {bookOfBusinessResponseService === BOB_SERVICES.PROFILES ? item.linkedinUrl : [BOB_SERVICES.COMPANIES, BOB_SERVICES.PRODUCT_AND_SERVICES].includes(bookOfBusinessResponseService) ? item.landingPageUrl : ""}
                  //         </a>
                  //       </p>
                  //     </td>
                  //     <td>{currentStatus(item)}</td>
                  //     {/* <td>
                  //       {actionToBeTaken(item)}
                  //     </td> */}
                  //   </tr>
                  //   :
                  <tr key={getProfileId(item) || index}>
                    <td className="profileSelectColumn">
                      <input
                        type="checkbox"
                        checked={selectedProfileIds.includes(getProfileId(item))}
                        onChange={(e) => handleProfileSelect(item, e.target.checked)}
                      />
                    </td>
                    <td className="isVerifiedIcon">
                      <p>
                        {getProfileName(item)}
                      </p>
                      {item?.is_verified && (
                        <span className="vpVerified">
                          <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M5.34778 2.09697C5.85112 1.14739 6.84948 0.5 8 0.5C9.15052 0.5 10.1489 1.14739 10.6522 2.09697C11.6796 1.78143 12.8433 2.0296 13.6569 2.84315C14.4704 3.65669 14.7186 4.82041 14.403 5.84778C15.3526 6.35112 16 7.34948 16 8.5C16 9.65052 15.3526 10.6489 14.403 11.1522C14.7186 12.1796 14.4704 13.3433 13.6569 14.1569C12.8433 14.9704 11.6796 15.2186 10.6522 14.903C10.1489 15.8526 9.15052 16.5 8 16.5C6.84947 16.5 5.85112 15.8526 5.34778 14.903C4.32041 15.2186 3.15669 14.9704 2.34314 14.1569C1.52961 13.3433 1.28144 12.1796 1.59698 11.1522C0.647392 10.6489 0 9.65052 0 8.5C0 7.34948 0.647391 6.35112 1.59697 5.84778C1.28143 4.82041 1.5296 3.65669 2.34314 2.84314C3.15669 2.0296 4.32041 1.78143 5.34778 2.09697ZM11.81 6.49246C11.8686 6.55104 11.8686 6.64602 11.81 6.70459L7.07236 11.4422C7.01378 11.5008 6.91881 11.5008 6.86023 11.4422L4.24393 8.82591C4.18536 8.76734 4.18536 8.67236 4.24393 8.61378L5.09246 7.76525C5.15104 7.70668 5.24602 7.70668 5.30459 7.76525L6.86023 9.32089C6.91881 9.37947 7.01378 9.37947 7.07236 9.32089L10.7493 5.64393C10.8079 5.58536 10.9029 5.58536 10.9614 5.64393L11.81 6.49246Z"
                              fill={'#2978b5'}
                            />
                            <path
                              d="M11.81 6.70459C11.8686 6.64602 11.8686 6.55104 11.81 6.49246L10.9614 5.64393C10.9029 5.58536 10.8079 5.58536 10.7493 5.64393L7.07236 9.32089C7.01378 9.37947 6.91881 9.37947 6.86023 9.32089L5.30459 7.76525C5.24602 7.70668 5.15104 7.70668 5.09246 7.76525L4.24393 8.61378C4.18536 8.67236 4.18536 8.76734 4.24393 8.82591L6.86023 11.4422C6.91881 11.5008 7.01378 11.5008 7.07236 11.4422L11.81 6.70459Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      )}
                    </td>
                    <td>
                      <p>
                        {item?.role || "-"}
                      </p>
                    </td>
                    <td>
                      <p>
                        <TimeFormat time={item?.created_at} />
                      </p>
                    </td>
                    <td>
                      <p>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={item.linkedinUrl}>
                          {item.linkedinUrl}
                        </a>
                      </p>
                    </td>
                    <td>
                      <p>
                        {item?.location || "-"}
                      </p>
                    </td>
                    <td>
                      <p className="aboutSection">
                        {item?.about || "-"}
                      </p>
                    </td>
                    <td>
                      <div className="">
                        <button
                          onClick={() => handleViewProfile(item)}
                          className="btn save-btn editButton"
                        >
                          View Detail
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="d-flex pt-3">
                  <td className="d-flex flex-column justify-content-center">
                    <h6 className="table-heading text-nowrap">
                      No record found
                    </h6>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {count > 0 && (
          <div className="tableBottom">
            <div className="filterButton">
              <div className="dropdownButton">
                <Controller
                  name="limit"
                  control={control}
                  render={({ field }) => (
                    <Form.Select
                      {...field}
                      className="select-border"
                      placeholder="10"
                    >
                      <option value={25}>25</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </Form.Select>
                  )}
                />
              </div>
            </div>
            <div>
              <ReactPaginate
                previousLabel={<i className="fas fa-chevron-left"></i>} // Font Awesome icon for previous
                nextLabel={<i className="fas fa-chevron-right"></i>} // Font Awesome icon for next
                pageCount={count}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePageClick}
                containerClassName={"pagination customPagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={activePage}
              />
            </div>
          </div>
        )}
      </div>

      <ImportFile
        bookOfBusiness={bookOfBusiness}
        importOpen={importOpen}
        importClose={() => setImportOpen(false)}
        companyDetail={getValues("companyName")}
        status={profileTab}
        limit={limit}
      />

      <ProfileForm
        formOpen={formOpen}
        formClose={() => setFormOpen(false)}
        // companyDetail={getValues("companyName")}
        companyDetail={isEdit ? (getValues("companyName") && Object.keys(getValues("companyName")).length > 0 ? getValues("companyName") : customCompanyDetails) : getValues("companyName")}
        bobSelected={bobSelected}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        limit={limit}
        setStatus={setStatus}
        setPage={setPage}
        setActivePage={setActivePage}
        status={profileTab}
        bookOfBusiness={bookOfBusiness}
      />

      <ContactInfo
        contactOpen={contactOpen}
        contactClose={() => setContactOpen(false)}
        bookOfBusinessResponseService={bookOfBusinessResponseService}
      />

      <ConfirmMeeting
        meetingOpen={meetingOpen}
        meetingClose={() => setMeetingOpen(false)}
        handleConnect={handleConnect}
        item={meetingDetailItem}
      />
      <SendToChat
        meetingOpen={sendToChatModal}
        meetingClose={() => setSendToChatModal(false)}
        handleConnect={handleChatResponse}
        item={sendToChatDetail} />

      <ViewProfileModal
        show={open}
        onClose={() => setOpen(false)}
        profile={profileData}
        pageType={2}
      />

      <Modal
        show={campaignModalOpen}
        onHide={closeCampaignModal}
        centered
        className="moddal-primary importModal ps-0"
      >
        <Modal.Body>
          <div className="modelHeader">
            <h3>Add Profiles To Campaign</h3>
            <div
              className="modelCloseButton"
              onClick={closeCampaignModal}
            >
              <img src="assets/img/closeIcon.svg" alt="" />
            </div>
          </div>

          <div className="vpFormGroup mt-3">
            <label className="vpLabel">
              Select campaign
            </label>
            <Select
              className="select-border"
              theme={SELECT_BOX_THEME}
              styles={styleSelect}
              options={Array.isArray(campaignList) ? campaignList : []}
              value={selectedCampaign}
              onChange={setSelectedCampaign}
              getOptionLabel={(option) => option?.name + (option?.creator ? ` (${option?.creator?.first_name} ${option?.creator?.last_name})` : "asd") || "-"}
              getOptionValue={(option) => option?.id || option?._id}
              placeholder="Select campaign"
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <p className="mb-0">
              Selected profiles: {selectedProfileIds.length}
            </p>
            <button
              type="button"
              className="customAddButton removePadding"
              disabled={bulkCampaignLoading}
              onClick={handleAddSelectedProfilesToCampaign}
            >
              {bulkCampaignLoading ? "Adding..." : "Add to campaign"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
